<template>
    <div class="vm-block-plan">
        <!-- <div class="mt32 mb16 fs20 fwb black-8">订阅方案</div> -->
        <div class="mb16">
            <div class="fs20 fwb black-8">{{$t('c.BlockPlan.text1')}}</div>
            <span class="fs12 black-3 mt4">{{$t('c.BlockPlan.text2')}}</span>
        </div>
        <div class="flex-box mb16">
          <dropdown class="plan-dropdown" :options="status_list" :value.sync="status"/>
        </div>
        <template v-if="has_update">
          <plan-edit
              class="mb16"
              v-for="(plan, i) in plan_list"
              :key="plan.plan_id"
              :plan="plan"
              :index="i"
              @save="save_plan"
              @remove="remove_plan(i)"/>
        </template>
        <btn
            class="size40 w100 look2"
            @click.native="add_plan"
        >{{$t('c.BlockPlan.text3')}}</btn>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { GET_ALL_PLANS } from "@/api/config";
export default {
    name: "plan",
    data() {
        return {
            plan_count: 1,
            t: new Date().getTime(),
            has_update:true,
            status:'',
            status_list:[
                {name:'全部',value:''},
                {name:'已上架',value:'1'},
                {name:'已隐藏',value:'3'},
            ],
        };
    },
    watch:{
      status(){
        this.get_plan()
      }
    },
    computed: {
        ...mapState("app", [
            "session_user",
            "user_status",
            "upload",
            "plan_list",
            "plan_sale_list",
        ]),
        post_data(){
          return {
            status:this.status
          }
        },
        is_creator() {
            if (
                this.session_user &&
                this.session_user.creator &&
                this.session_user.creator.status
            ) {
                return true;
            }
            return false;
        },
         is_apply(){
            return this.$route && this.$route.name == 'apply'
        },
        tit() {
            if (!this.is_creator) {
                return this.$t('c.BlockPlan.text4');
            }
            return this.$t('c.BlockPlan.text5');
        },
    },
    async mounted() {
        // await this.$store.dispatch("app/get:plan_list");
        // if (this.plan_list.length == 0) {
        // }
        this.get_plan()
    },
    methods: {
        uid() {
            return "t" + Math.random();
        },
        add_plan(type = "") {
            let key = "app/push:plan_list";
            if (type == "sale") {
                key = "app/push:plan_sale_list";
            }
            this.plan_count++;
            this.$store.dispatch(key, {_id: this.plan_count,config:{}});
        },
        remove_plan(i, type = "") {
            let key = "app/splice:plan_list";
            if (type == "sale") {
                key = "app/splice:plan_sale_list";
            }
            this.$store.dispatch(key, [i, 1]);
        },
        save_plan(param) {
            let key = "app/splice:plan_list";
            if (param.plan.product_type == 1) {
                key = "app/splice:plan_sale_list";
            }
            // this.has_update = false
            this.$store.dispatch(key, [param.index, 1, param.plan]);
            this.$nextTick(() => {
                // this.has_update = true;
            })
        },
        get_plan(){
          this.$store.dispatch("app/get:plan_list",this.post_data);
        },
        async next() {
            if (this.$http.is_run(GET_ALL_PLANS)) {
                return false;
            }
            let data = await this.$http.$axios(GET_ALL_PLANS);

            if (data.ec != 200) {
                this.$notify({
                    title: data.em,
                    group: "error",
                });
            }
            if (this.is_creator && data.ec == 200) {
                this.$notify({
                    title: data.em,
                    group: "success",
                });
            }
            this.$router.push({ name: "settingGoal" });
        },
    },
};
</script>

<style lang="stylus" scoped>
.vm-block-plan {
  .plan-dropdown /deep/{
    border:0;
    .show-area{
      padding: 4px 12px 4px 0;
      color:$black-5;
    }
  }
}
</style>
